import { omitBy, isNull } from 'lodash-es';
import { MarketingMeta } from './marketingMeta.types';

export const extractMarketingMeta = (): MarketingMeta => {
  const searchParams = new URLSearchParams(window?.location?.search);
  const rawMarketingMeta = {
    gclid: searchParams.get('gclid'),
    adfcd: searchParams.get('adfcd'),
    fbclid: searchParams.get('fbclid'),
    msclkid: searchParams.get('msclkid'),
    utm_source: searchParams.get('utm_source'),
    utm_medium: searchParams.get('utm_medium'),
    utm_campaign: searchParams.get('utm_campaign'),
    utm_content: searchParams.get('utm_content'),
    utm_term: searchParams.get('utm_term'),
    utm_variant: searchParams.get('utm_variant'),
    referral_code: searchParams.get('referral_code'),
    btag: searchParams.get('btag'),
    s1: searchParams.get('s1'),
    t1: searchParams.get('t1'),
    lpageid: searchParams.get('lpageid'),
    ad_group: searchParams.get('ad_group'),
    adset: searchParams.get('adset'),
    creative: searchParams.get('creative'),
    keyword: searchParams.get('keyword'),
    network: searchParams.get('network'),
    wbraid: searchParams.get('wbraid'),
    gbraid: searchParams.get('gbraid'),
    ttclid: searchParams.get('ttclid'),
    dclid: searchParams.get('dclid'),
  };

  const referralCode = window?.location?.pathname
    ?.match(/^\/join\/(.+)/g)?.[0]
    ?.split('/join/')[1];

  if (referralCode) {
    rawMarketingMeta.referral_code = referralCode;
  }

  return omitBy(rawMarketingMeta, isNull);
};
